(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["hs-cart-campaign"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('hs-cart-campaign')) {
  const previous = new Map();
  customElements.define('hs-cart-campaign', class extends HTMLElement {
    connectedCallback() {
      this.context = this.closest('cart-drawer') ? 'drawer' : 'page';
      this.ratio = Number(this.dataset.ratio);
      const prev = previous.get(this.context);
      if (!prev || matchMedia('(prefers-reduced-motion: reduce)').matches || Date.now() - prev.time > 2500 || prev.ratio === this.ratio) return;
      this.querySelector('.hs-camp__fill')?.animate([{ transform: `scaleX(${prev.ratio})` }, { transform: `scaleX(${this.ratio})` }], { duration: 480, easing: 'cubic-bezier(.22,.61,.36,1)' });
    }
    disconnectedCallback() { previous.set(this.context, { ratio: this.ratio, time: Date.now() }); }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["hs-cart-shipping-progress"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('hs-cart-shipping-progress')) {
  const previousShippingStates = new Map();
  let suggestionSequence = 0;
  customElements.define('hs-cart-shipping-progress', class extends HTMLElement {
    connectedCallback() {
      this.drawer = this.closest('cart-drawer');
      this.context = this.drawer ? 'drawer' : 'page';
      this.ratio = Number(this.dataset.ratio);
      const previous = previousShippingStates.get(this.context);
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (previous && Date.now() - previous.time < 2000 && previous.ratio !== this.ratio && !reduced) {
        this.querySelector('.hs-shipping-progress__fill')?.animate([
          {transform: `scaleX(${previous.ratio})`},
          {transform: `scaleX(${this.ratio})`}
        ], {duration:340, easing:'cubic-bezier(.22,.61,.36,1)'});
        if (previous.ratio < 1 && this.ratio === 1) this.querySelector('.hs-shipping-progress__icon')?.animate([
          {opacity:0, transform:'scale(.86)'}, {opacity:1, transform:'scale(1)'}
        ], {duration:280, easing:'ease-out'});
      }
      if (!this.dataset.recommendUrl) return;
      this.controller = new AbortController();
      this.trigger = this.querySelector('.hs-shipping-progress__discover');
      this.trigger?.addEventListener('click', () => this.toggleSuggestions(), {signal:this.controller.signal});
      this.observer = new IntersectionObserver(entries => {
        if (!entries.some(entry => entry.isIntersecting)) return;
        this.observer.disconnect();
        this.loadSuggestions();
      });
      this.observer.observe(this);
    }
    disconnectedCallback() {
      previousShippingStates.set(this.context, {ratio:this.ratio, time:Date.now()});
      this.controller?.abort();
      this.observer?.disconnect();
      this.suggestions?.remove();
    }
    async loadSuggestions() {
      try {
        const response = await fetch(this.dataset.recommendUrl, {credentials:'same-origin', signal:this.controller.signal, headers:{Accept:'text/html'}});
        if (!response.ok) return;
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        const source = html.querySelector('[data-hs-shipping-suggestions]');
        if (!this.isConnected || source?.dataset.signature !== this.dataset.signature || !source.querySelector('a')) return;
        const target = this.drawer?.querySelector('.drawer__cart-items-wrapper') || document.querySelector('#main-cart-footer');
        if (!target || !this.trigger) return;
        source.id = `hs-shipping-suggestions-${++suggestionSequence}`;
        source.hidden = true;
        this.suggestions = source;
        target.append(source);
        this.trigger.setAttribute('aria-controls', source.id);
        this.trigger.hidden = false;
        source.querySelector('[data-hs-shipping-close]')?.addEventListener('click', () => {
          source.hidden = true;
          this.trigger.setAttribute('aria-expanded', 'false');
          this.trigger.focus({preventScroll:true});
        }, {signal:this.controller.signal});
      } catch (_) {}
    }
    toggleSuggestions() {
      if (!this.suggestions) return;
      const opening = this.suggestions.hidden;
      this.suggestions.hidden = !opening;
      this.trigger.setAttribute('aria-expanded', String(opening));
      if (opening) {
        this.suggestions.scrollIntoView({block:'nearest', behavior:'auto'});
        this.suggestions.querySelector('a')?.focus({preventScroll:true});
      }
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["hs-commerce"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('hs-commerce'))customElements.define('hs-commerce',class extends HTMLElement{
 connectedCallback(){
  if(this.ready)return;this.ready=true;this.events=new AbortController();const options={signal:this.events.signal};
  this.viewport=()=>{const height=window.visualViewport?.height||innerHeight,value=height+'px',keyboard=height<innerHeight*.78&&Boolean(document.activeElement?.matches('input,textarea,[contenteditable=true]'));if(document.documentElement.style.getPropertyValue('--hs-visual-height')!==value)document.documentElement.style.setProperty('--hs-visual-height',value);if(document.body.hasAttribute('data-hs-keyboard')!==keyboard)document.body.toggleAttribute('data-hs-keyboard',keyboard);};
  window.visualViewport?.addEventListener('resize',this.viewport,options);window.addEventListener('resize',this.viewport,options);document.addEventListener('focusin',this.viewport,options);document.addEventListener('focusout',this.viewport,options);this.viewport();
  document.addEventListener('click',event=>{
   const link=event.target.closest('a[href*="/products/"]');
   if(link&&link.closest('.hs-ux-card,.product-card-wrapper,.predictive-search'))document.dispatchEvent(new CustomEvent('hardstone:commerce',{detail:{event:'product_click',path:new URL(link.href,location.href).pathname}}));
  },options);
 }
 disconnectedCallback(){this.events?.abort();document.documentElement.style.removeProperty('--hs-visual-height');document.body.removeAttribute('data-hs-keyboard');this.ready=false;}
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["hs-home-transition"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('hs-home-divider'))customElements.define('hs-home-divider',class extends HTMLElement{
 connectedCallback(){
  if(this.seen||!('IntersectionObserver' in window))return;
  this.reduced=matchMedia('(prefers-reduced-motion: reduce)');
  if(this.reduced.matches)return;
  this.cancel=()=>{if(this.reduced.matches){this.effect?.cancel();this.observer?.disconnect();}};
  this.reduced.addEventListener('change',this.cancel);
  this.observer=new IntersectionObserver(entries=>{
   if(!entries.some(entry=>entry.isIntersecting))return;
   this.seen=true;this.observer.disconnect();
   if(!this.reduced.matches)this.effect=this.animate([{opacity:.35,transform:'scaleX(.25)'},{opacity:1,transform:'scaleX(1)'}],{duration:380,easing:'cubic-bezier(.2,.65,.3,1)'});
  },{rootMargin:'0px 0px -28px 0px'});
  this.observer.observe(this);
 }
 disconnectedCallback(){this.observer?.disconnect();this.effect?.cancel();if(this.cancel)this.reduced?.removeEventListener('change',this.cancel);}
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["hs-journey-context"] && !Shopify.designMode) return;
  try {
    (() => {
  const config = document.getElementById('HsCoreContextConfig'); if (!config) return;
  const labels = JSON.parse(config.textContent), key = 'hs_core_journey_v2';
  const validPaths = {outdoor:['all','forest','wetland','open','mixed'],cold:['all','base','mid','outer','bottom','system'],hunting:['all','duck','duck-wetland','woodcock','boar','rabbit'],camping:['all','bottom','base','mid','shell','outer','accessory']};
  const valid = value => value && validPaths[value.journey]?.includes(value.path) && Date.now()-value.at < 7200000 && Date.now() >= value.at;
  let context;
  try { const saved = JSON.parse(sessionStorage.getItem(key) || 'null'); if (valid(saved)) context = saved; else sessionStorage.removeItem(key); } catch (_) {}
  const source = new URL(document.baseURI), journey = document.querySelector('[data-hs-journey]');
  if (journey) context = {journey:journey.dataset.hsJourney,path:journey.dataset.hsPath,at:Date.now()};
  else if (source.searchParams.has('use_case')) context = {journey:source.searchParams.get('use_case'),path:source.searchParams.get('discovery_path') || 'all',at:Date.now()};
  if (!valid(context)) context = null;
  if (context) { try { sessionStorage.setItem(key, JSON.stringify(context)); } catch (_) {} }
  const productPage = !!document.querySelector('product-info');
  const decorate = () => {
    if (!context || !productPage) return;
    const label = labels.journeys[context.journey] + (context.path === 'all' ? '' : ' › ' + labels.paths[context.path]);
    const destination = labels.search + '?view=hs-discovery&q=' + context.journey + '.' + context.path + '.all.1';
    document.querySelectorAll('[data-hs-context-bar]').forEach(bar => {const link = bar.querySelector('[data-hs-context-link]');link.textContent = label;link.href = destination;bar.hidden=false;});
    document.querySelectorAll('[data-hs-continuation]').forEach(surface => { const link=surface.querySelector('a');link.href=destination;link.textContent=labels.continue.replace('[context]',context.path === 'all' ? labels.journeys[context.journey] : labels.paths[context.path]);surface.hidden=false; });
  };
  document.addEventListener('click', event => {
    if (event.target.closest('[data-hs-context-clear]')) { context=null;try{sessionStorage.removeItem(key);}catch(_){}document.querySelectorAll('[data-hs-context-bar],[data-hs-continuation]').forEach(n=>n.hidden=true);return; }
    const link = event.target.closest('a[href]'); if (!link || !context) return;
    const url = new URL(link.href,document.baseURI);
    if (url.origin !== source.origin || !url.pathname.includes('/products/')) return;
    url.searchParams.set('use_case',context.journey);url.searchParams.set('discovery_path',context.path);link.href=url.href;
  },true);
  document.addEventListener('hardstone:guidance-ready',decorate);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',decorate,{once:true});else decorate();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["hs-motion"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('hs-storefront-motion'))customElements.define('hs-storefront-motion',class extends HTMLElement{
 connectedCallback(){
  if(this.ready)return;this.ready=true;
  this.events=new AbortController();this.reduced=matchMedia('(prefers-reduced-motion: reduce)');this.bound=new WeakSet();this.effects=new Set();
  this.play=(element,frames,options)=>{
   if(!element||this.reduced.matches||document.hidden||typeof element.animate!=='function')return;
   const effect=element.animate(frames,options);this.effects.add(effect);effect.finished.catch(()=>{}).finally(()=>this.effects.delete(effect));
  };

  // Feedback never captures a pointer or delays a link. Scroll/drag cancels it immediately.
  const clearPress=()=>{this.pressedCard?.removeAttribute('data-hs-pressed');this.pressedCard=null;};
  document.addEventListener('pointerdown',event=>{
   clearPress();
   if(this.reduced.matches||event.isPrimary===false||event.button!==0||!['touch','pen'].includes(event.pointerType))return;
   const card=event.target.closest('[data-hs-product-card]');
   if(!card||event.target.closest('button,input,select,summary'))return;
   this.pressedCard=card;this.pressPoint={id:event.pointerId,x:event.clientX,y:event.clientY};card.setAttribute('data-hs-pressed','');
  },{passive:true,signal:this.events.signal});
  document.addEventListener('pointermove',event=>{
   if(this.pressedCard&&event.pointerId===this.pressPoint.id&&Math.hypot(event.clientX-this.pressPoint.x,event.clientY-this.pressPoint.y)>8)clearPress();
  },{passive:true,signal:this.events.signal});
  ['pointerup','pointercancel','scroll'].forEach(type=>document.addEventListener(type,clearPress,{capture:true,passive:true,signal:this.events.signal}));
  window.addEventListener('blur',clearPress,{signal:this.events.signal});
  window.addEventListener('pagehide',()=>{clearPress();this.effects.forEach(effect=>effect.cancel());},{signal:this.events.signal});
  window.addEventListener('pageshow',event=>{if(event.persisted){clearPress();this.effects.forEach(effect=>effect.cancel());}},{signal:this.events.signal});
  this.clearPress=clearPress;
  this.reduce=()=>{if(this.reduced.matches){this.clearPress();this.effects.forEach(effect=>effect.cancel());}this.syncVideo?.();};
  this.reduced.addEventListener('change',this.reduce);
  const token=getComputedStyle(document.body);this.motion=name=>parseFloat(token.getPropertyValue(name))||200;
  if('IntersectionObserver' in window&&!this.reduced.matches){
   const ease=token.getPropertyValue('--ease-enter').trim()||'ease-out';
   const register=element=>{
    if(this.bound.has(element))return;
    this.bound.add(element);
    if(element.getBoundingClientRect().top>innerHeight)this.sectionObserver.observe(element);
   };
   this.sectionObserver=new IntersectionObserver(entries=>entries.forEach(entry=>{
    if(!entry.isIntersecting)return;
    this.sectionObserver.unobserve(entry.target);
    const element=entry.target;
    const home=element.closest('[data-hs-home-flow]');
    if(home){
     if(element.matches('.hs-ux-rail__heading')){
      this.play(element.querySelector('h2'),[{opacity:.55,transform:'translateY(12px)'},{opacity:1,transform:'none'}],{duration:440,easing:ease});
      this.play(element.querySelector('a'),[{opacity:.65,transform:'translateY(6px)'},{opacity:1,transform:'none'}],{duration:340,delay:60,easing:ease});
     }else if(element.matches('[data-hs-transition-art]')){
      element.querySelectorAll('[data-hs-art-piece]').forEach((piece,index)=>this.play(piece,[{opacity:.5,transform:'translateY(14px)'},{opacity:1,transform:'none'}],{duration:520,delay:index*65,easing:ease}));
     }else{
      const index=Number(element.dataset.hsEntryIndex)||0;
      this.play(element,[{opacity:.7,transform:'translateY(12px)'},{opacity:1,transform:'none'}],{duration:400,delay:index*45,easing:ease});
     }
     return;
    }
    const items=element.matches('.hs-ux-rail__track')?[...element.children].filter(item=>!item.hidden).slice(0,4):[element];
    items.forEach((item,index)=>{
     const bounds=item.getBoundingClientRect();
     if(bounds.right<0||bounds.left>innerWidth)return;
     this.play(item,[{opacity:.72,transform:'translateY(10px)'},{opacity:1,transform:'none'}],{duration:this.motion('--motion-emphasis'),delay:index*35,easing:ease});
    });
   }),{threshold:0,rootMargin:'0px 0px -28px 0px'});
   const observe=scope=>{
    scope.querySelectorAll('[data-hs-home-flow]').forEach(home=>{
     home.querySelectorAll('.hs-ux-rail__heading,[data-hs-transition-art]').forEach(register);
     const track=home.querySelector('.hs-ux-rail__track');
     if(!track)return;
     const cards=[...track.children];
     const firstTop=cards[0]?.offsetTop;
     let index=0;
     cards.forEach(card=>{
      if(card.offsetTop!==firstTop)return;
      card.dataset.hsEntryIndex=String(index++);
      register(card);
     });
    });
    scope.querySelectorAll('.hs-catalogue-heading,.hs-ux-rail__heading,.hs-ux-rail__track,.related-products>h2').forEach(element=>{
     if(!element.closest('[data-hs-home-flow]'))register(element);
    });
   };
   observe(document);
   document.addEventListener('shopify:section:load',event=>observe(event.target),{signal:this.events.signal});
   document.addEventListener('shopify:section:unload',event=>{
    event.target.querySelectorAll('.hs-ux-rail__heading,[data-hs-transition-art],.hs-ux-rail__track>li').forEach(element=>this.sectionObserver.unobserve(element));
   },{signal:this.events.signal});
  }
  if(typeof subscribe==='function'&&typeof PUB_SUB_EVENTS!=='undefined'){
   this.cartUnsubscribe=subscribe(PUB_SUB_EVENTS.cartUpdate,()=>{
    requestAnimationFrame(()=>{
     if(!this.isConnected)return;
     const drawer=document.querySelector('cart-drawer.active');
     if(!drawer)return;
     this.play(document.querySelector('.cart-count-bubble'),[{transform:'scale(.9)'},{transform:'scale(1)'}],{duration:220,easing:token.getPropertyValue('--ease-micro').trim()||'ease-out'});
     this.play(drawer.querySelector('.totals'),[{opacity:.55,transform:'translateY(4px)'},{opacity:1,transform:'none'}],{duration:this.motion('--motion-standard'),easing:'ease-out'});
    });
   });
  }
  this.pageTransition=event=>{
   const transition=event.viewTransition;if(!transition)return;
   const destination=event.activation?.entry?.url;
   if(this.reduced.matches||event.type==='pageswap'&&(!destination||!/^\/(?:$|cart\/?$|(?:products|collections)\/)/.test(new URL(destination,location.href).pathname))){transition.skipTransition();return;}
   const cancel=()=>transition.skipTransition();
   const inputs=['pointerdown','keydown','wheel','touchmove'];
   inputs.forEach(type=>document.addEventListener(type,cancel,{once:true,passive:true,signal:this.events.signal}));
   const cleanup=()=>inputs.forEach(type=>document.removeEventListener(type,cancel));transition.finished.then(cleanup,cleanup);
  };
  window.addEventListener('pageswap',this.pageTransition,{signal:this.events.signal});window.addEventListener('pagereveal',this.pageTransition,{signal:this.events.signal});
   this.video=document.getElementById('HardstoneHeroVideo');
   if(this.video){
    this.video.muted=true;
    this.video.defaultMuted=true;
    this.video.loop=true;
    this.video.playsInline=true;
    this.video.controls=false;
    this.video.setAttribute('playsinline','');
    this.video.setAttribute('webkit-playsinline','');
    this.video.preload='metadata';

    this.mobileHero=matchMedia('(max-width:767px)');
    this.videoVisible=false;

    this.syncVideo=()=>{
     const staticHero=this.reduced.matches;
     const paused=document.hidden||!this.videoVisible||!this.mobileHero.matches||staticHero;

     this.video.toggleAttribute('data-hs-static-hero',staticHero);

     if(paused){
      this.video.pause();
      return;
     }

     this.video.removeAttribute('data-hs-autoplay-blocked');

     const playback=this.video.play();
     if(playback&&typeof playback.catch==='function'){
      playback.catch(()=>{
       this.video.setAttribute('data-hs-autoplay-blocked','');
      });
     }
    };

    this.mobileHero.addEventListener('change',this.syncVideo);

    if('IntersectionObserver' in window){
     this.videoObserver=new IntersectionObserver(entries=>{
      this.videoVisible=entries[0].isIntersecting;
      this.syncVideo();
     });
     this.videoObserver.observe(this.video);
    }else{
     this.videoVisible=true;
    }

    this.syncVideo();
   }
  document.addEventListener('visibilitychange',()=>{this.syncVideo?.();if(document.hidden)this.effects.forEach(effect=>effect.cancel());},{signal:this.events.signal});
 }
  disconnectedCallback(){this.clearPress?.();this.cartUnsubscribe?.();this.mobileHero?.removeEventListener('change',this.syncVideo);this.events?.abort();this.sectionObserver?.disconnect();this.videoObserver?.disconnect();this.reduced?.removeEventListener('change',this.reduce);this.effects?.forEach(effect=>effect.cancel());this.ready=false;}
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["hs-navigation"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('hs-navigation'))customElements.define('hs-navigation',class extends HTMLElement{
 connectedCallback(){
  if(this.ready)return;this.ready=true;this.events=new AbortController();this.transition=0;this.effects=[];
  this.disclosure=this.querySelector('.hs-nav-disclosure');this.trigger=this.disclosure.querySelector(':scope > summary');this.panel=this.querySelector('.hs-nav-panel');this.scrim=this.querySelector('.hs-nav-scrim');
  const options={signal:this.events.signal};
  this.scrollPanel=this.querySelector('.hs-nav-scroll');
  this.persist=()=>{if(!this.disclosure.open)return;try{sessionStorage.setItem('hs-navigation-v2',JSON.stringify({time:Date.now(),open:[...this.querySelectorAll('[data-hs-nav-key][open]')].map(el=>el.dataset.hsNavKey),scroll:this.scrollPanel.scrollTop}));}catch{}};
  this.restore=()=>{try{const saved=JSON.parse(sessionStorage.getItem('hs-navigation-v2'));if(saved&&Date.now()-saved.time<1800000){this.querySelectorAll('[data-hs-nav-key]').forEach(el=>{el.open=saved.open.includes(el.dataset.hsNavKey);});this.scrollPanel.scrollTop=saved.scroll||0;}}catch{}};
  this.addEventListener('click',event=>{if(event.target.closest('a'))this.persist();},options);
  window.addEventListener('pagehide',this.persist,options);
  this.trigger.addEventListener('click',event=>{event.preventDefault();if(this.closing||!this.disclosure.open)this.open();else this.close();},options);
  this.querySelectorAll('[data-hs-nav-close]').forEach(button=>button.addEventListener('click',()=>this.close(),options));
  this.addEventListener('keydown',event=>{if(event.key==='Escape'&&this.disclosure.open){event.preventDefault();event.stopPropagation();this.close();}},options);
  this.querySelectorAll('.hs-nav-group').forEach(group=>group.addEventListener('toggle',()=>{if(group.open)this.querySelectorAll('.hs-nav-group').forEach(other=>{if(other!==group)other.open=false;});},options));
 }
 stop(){this.effects.forEach(effect=>effect.cancel());this.effects=[];}
 open(){
  const from=this.disclosure.open?getComputedStyle(this.panel).transform:'translateX(-100%)';
  const overlayFrom=this.disclosure.open?getComputedStyle(this.scrim).opacity:0;
  ++this.transition;this.stop();this.closing=false;
  document.querySelector('cart-drawer.active')?.close(true,false);
  document.querySelector('details-modal.hs-search details[open]')?.closest('details-modal').close(false);
  this.disclosure.open=true;this.restore();this.trigger.setAttribute('aria-expanded','true');document.body.classList.add('overflow-hidden','hs-nav-open');
  if(typeof trapFocus==='function')trapFocus(this.panel,this.panel.querySelector('[data-hs-nav-close]'));
  this.effects=window.HardstoneMotion?.panel(this.panel,this.scrim,{phase:'enter',side:'left',from,overlayFrom})||[];
 }
 unlock(restore=true){this.trigger.setAttribute('aria-expanded','false');document.body.classList.remove('hs-nav-open');if(!document.querySelector('cart-drawer.active'))document.body.classList.remove('overflow-hidden');if(typeof removeTrapFocus==='function')removeTrapFocus();if(restore){try{this.trigger.focus({preventScroll:true});}catch{this.trigger.focus();}}}
 async close(immediate=false,restore=true){
  if(!this.disclosure.open||this.closing&&!immediate)return;
  this.persist();
  const from=getComputedStyle(this.panel).transform,overlayFrom=getComputedStyle(this.scrim).opacity;const token=++this.transition;this.stop();this.closing=true;
  if(!immediate){
   this.effects=window.HardstoneMotion?.panel(this.panel,this.scrim,{phase:'exit',side:'left',from,overlayFrom})||[];
   await Promise.allSettled(this.effects.map(effect=>effect.finished));
  }
  if(token!==this.transition)return;
  this.disclosure.open=false;this.closing=false;this.stop();this.unlock(restore);
 }
 disconnectedCallback(){++this.transition;this.stop();this.events?.abort();this.ready=false;}
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["hs-pilot-purchase"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('hs-product-purchase')) {
  customElements.define('hs-product-purchase', class extends HTMLElement {
    connectedCallback() {
      if (this.events) return;
      this.events = new AbortController();
      this.addEventListener('click', event => {
        const button = event.target.closest('[data-hs-checkout]');
        if (!button || !this.contains(button)) return;
        event.preventDefault();
        this.checkout(button);
      }, {signal:this.events.signal});
      window.addEventListener('pageshow', event => {
        if (event.persisted) this.restore();
      }, {signal:this.events.signal});
    }
    disconnectedCallback() {
      this.events?.abort();
      this.events = null;
    }
    restore() {
      this.controls?.forEach(([control, disabled]) => { control.disabled = disabled; });
      this.controls = null;
      if (this.label && this.originalLabel !== undefined) this.label.textContent = this.originalLabel;
      this.trigger?.removeAttribute('aria-busy');
      this.pending = false;
    }
    async checkout(button) {
      if (this.pending || button.disabled) return;
      const form = button.closest('form');
      const host = button.closest('product-form');
      const variant = form?.querySelector('[name="id"]');
      const add = form?.querySelector('[name="add"]');
      if (!form || !variant?.value || variant.disabled || add?.disabled || add?.getAttribute('aria-disabled') === 'true') {
        host?.handleErrorMessage(this.dataset.unavailableLabel);
        return;
      }
      if (!form.reportValidity()) return;
      const body = new FormData(form);
      if (!body.has('quantity')) body.set('quantity', '1');
      const endpoint = new URL(form.action, location.origin);
      if (!endpoint.pathname.endsWith('.js')) endpoint.pathname += '.js';
      this.pending = true;
      this.trigger = button;
      this.label = button.querySelector('span');
      this.originalLabel = this.label?.textContent;
      this.controls = [...this.querySelectorAll('button')].map(control => [control, control.disabled]);
      this.controls.forEach(([control]) => { control.disabled = true; });
      button.setAttribute('aria-busy', 'true');
      if (this.label) this.label.textContent = this.dataset.loadingLabel;
      host.handleErrorMessage();
      let rejected = false;
      try {
        const response = await fetch(endpoint, {
          method:'POST', body, credentials:'same-origin',
          headers:{Accept:'application/json'}, signal:AbortSignal.timeout(15000)
        });
        rejected = response.status >= 400 && response.status < 500;
        const result = await response.json();
        if (!response.ok || result.status) {
          throw new Error(typeof result.description === 'string' ? result.description : this.dataset.errorLabel);
        }
        location.assign(this.dataset.checkoutUrl);
      } catch (error) {
        this.restore();
        if (rejected) {
          host.handleErrorMessage(error.message || this.dataset.errorLabel);
          return;
        }
        this.pending = true;
        button.disabled = true;
        host.handleErrorMessage(this.dataset.uncertainLabel);
        const message = host.querySelector('.product-form__error-message');
        if (message) {
          const link = document.createElement('a');
          link.href = this.dataset.cartUrl;
          link.textContent = this.dataset.cartLabel;
          message.append(document.createTextNode(' '), link);
        }
      }
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["hs-product-price"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('hs-product-price'))customElements.define('hs-product-price',class extends HTMLElement{
  connectedCallback(){
    const amount=Number(this.dataset.amount),compare=Number(this.dataset.compare);
    if(!Number.isFinite(amount))return;
    try{
      const tr=this.dataset.currency==='TRY'&&/^tr/i.test(document.documentElement.lang||'tr');
      const intl=tr?null:new Intl.NumberFormat(document.documentElement.lang||'tr-TR',{style:'currency',currency:this.dataset.currency});
      const format={format:value=>tr?value.toLocaleString('tr-TR',{minimumFractionDigits:value%1?2:0,maximumFractionDigits:2})+' TL':intl.format(value)};
      this.querySelectorAll('.price__regular .price-item--regular:not(s),.price__sale .price-item--sale').forEach(node=>{node.textContent=format.format(amount/100);});
      if(compare>amount)this.querySelectorAll('s.price-item--regular').forEach(node=>{node.textContent=format.format(compare/100);});
    }catch(error){}
  }
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["hs-product-surface"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('hs-product-surface'))customElements.define('hs-product-surface',class extends HTMLElement{
  connectedCallback(){
    if(this.ready)return;this.ready=true;this.events=new AbortController();
    this.root=document.getElementById('MainProduct-'+this.dataset.section);
    if(!this.root)return;

    const thumbsForFit=this.root.querySelector('[id^="GalleryThumbnails-"]');
    const thumbList=thumbsForFit?.querySelector('.thumbnail-list');
    const centerActiveThumb=()=>{
      if(!thumbList||!matchMedia('(max-width:749px)').matches)return;
      const active=thumbList.querySelector('.thumbnail[aria-current="true"]')?.closest('.thumbnail-list__item');
      if(!active)return;
      const target=Math.max(0,active.offsetTop-(thumbList.clientHeight-active.offsetHeight)/2);
      thumbList.scrollTo({top:target,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
    };
    if(thumbList){
      let railProgress=thumbsForFit.querySelector('.hs-gallery-rail-progress');
      if(!railProgress){
        railProgress=document.createElement('span');
        railProgress.className='hs-gallery-rail-progress';
        railProgress.setAttribute('aria-hidden','true');
        railProgress.append(document.createElement('i'));
        thumbsForFit.append(railProgress);
      }
      const progressThumb=railProgress.querySelector('i');
      const updateRailProgress=()=>{
        const buttons=[...thumbList.querySelectorAll('.thumbnail-list__item .thumbnail')];
        const current=Math.max(0,buttons.findIndex(button=>button.getAttribute('aria-current')==='true'));
        const track=Math.max(0,railProgress.clientHeight-(progressThumb?.offsetHeight||24));
        const y=buttons.length>1?track*(current/(buttons.length-1)):0;
        const transform='translateY('+Math.round(y)+'px)';
        if(progressThumb&&progressThumb.style.transform!==transform)progressThumb.style.transform=transform;
      };
      thumbList.querySelectorAll('.thumbnail-list__item').forEach((item,index)=>item.style.setProperty('--hs-thumb-delay',Math.min(index,6)*42+'ms'));
      if(!matchMedia('(prefers-reduced-motion: reduce)').matches){
        thumbsForFit.dataset.hsRailIntro='true';
        setTimeout(()=>delete thumbsForFit.dataset.hsRailIntro,620);
      }
      let centerPending=false;
      this.thumbFrame=0;
      const scheduleRailUpdate=(center=false)=>{
        centerPending=centerPending||center;
        if(this.thumbFrame)return;
        this.thumbFrame=requestAnimationFrame(()=>{
          this.thumbFrame=0;
          const shouldCenter=centerPending;centerPending=false;
          if(!this.isConnected)return;
          if(shouldCenter)centerActiveThumb();
          updateRailProgress();
        });
      };
      this.thumbStateObserver=new MutationObserver(records=>{
        if(records.some(record=>record.attributeName==='aria-current'))scheduleRailUpdate(true);
      });
      this.thumbStateObserver.observe(thumbList,{subtree:true,attributes:true,attributeFilter:['aria-current']});
      scheduleRailUpdate(true);
      window.addEventListener('resize',()=>scheduleRailUpdate(),{passive:true,signal:this.events.signal});
    }

    const fit=this.root.querySelector('.hs-fit-advice');
    this.root.addEventListener('click',event=>{
      const trigger=event.target.closest('[data-hs-size-help]');
      if(!trigger||!fit)return;
      fit.open=!fit.open;
      trigger.setAttribute('aria-expanded',String(fit.open));
      if(fit.open)fit.scrollIntoView({block:'nearest',behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
    },{signal:this.events.signal});
    this.update=()=>{
      const selections=new Map();
      this.root.querySelectorAll('[data-hs-size-option]').forEach(group=>{
        if(!group.getClientRects().length)return;
        const selected=group.querySelector('input:checked');const label=group.querySelector('legend>span');
        if(selected&&label)selections.set(label.textContent.trim(),selected.value);
      });
      const text=[...selections].map(([label,value])=>label+' · '+value).join(' · ');
      const option=document.querySelector('[data-hs-sticky-option]');
      if(option&&option.textContent!==text)option.textContent=text;
      this.root.querySelectorAll('[data-hs-size-help]').forEach(button=>{button.hidden=!fit;button.setAttribute('aria-expanded',String(Boolean(fit?.open)));});
    };
    this.root.addEventListener('change',this.update,{signal:this.events.signal});
    this.root.addEventListener('click',event=>{
      const quantityButton=event.target.closest('.quantity__button');
      if(!quantityButton)return;
      const quantity=quantityButton.closest('.quantity');
      if(!quantity)return;
      quantity.classList.remove('hs-quantity-bump');
      requestAnimationFrame(()=>{quantity.classList.add('hs-quantity-bump');setTimeout(()=>quantity.classList.remove('hs-quantity-bump'),190);});
    },{signal:this.events.signal});
    fit?.addEventListener('toggle',this.update,{signal:this.events.signal});
    const variantHost=this.root.querySelector('variant-selects');
    if(variantHost){
      this.observer=new MutationObserver(()=>this.update());
      this.observer.observe(variantHost,{childList:true,subtree:true});
    }
    const initPdpMotion=()=>{
      if(matchMedia('(prefers-reduced-motion: reduce)').matches){
        document.querySelector('[data-hs2-relation-beacon]')?.setAttribute('data-hs-motion-visible','');
        return;
      }
      const navType=performance.getEntriesByType?.('navigation')?.[0]?.type;
      if(navType==='back_forward'){
        document.querySelector('[data-hs2-relation-beacon]')?.setAttribute('data-hs-motion-visible','');
        return;
      }

      const targets=[];
      const add=(node,kind='default',delay=0)=>{if(!node||targets.some(item=>item.node===node))return;targets.push({node,kind,delay});};
      const heroMedia=this.root.querySelector('.product__media-item.is-active .product__media, .product__media-item:first-child .product__media');
      if(heroMedia){heroMedia.classList.add('hs-hero-sheen');requestAnimationFrame(()=>heroMedia.dataset.hsLightSweep='true');}
      add(this.root.querySelector('.product__media-wrapper'),'media',0);
      add(this.root.querySelector('.product__title'),'heading',20);
      add(this.root.querySelector('.price'),'heading',70);
      add(this.root.querySelector('[data-hs-installment]'),'line',95);
      add(this.root.querySelector('[data-hs-usage-profile]'),'line',125);
      add(this.root.querySelector('[data-hs2-relation-beacon]'),'line',145);
      add(this.root.querySelector('variant-selects'),'default',0);
      add(this.root.querySelector('.hs-fit-option'),'default',45);
      add(this.root.querySelector('.product-form__quantity'),'line',0);
      add(this.root.querySelector('.hs-purchase-add'),'cta',30);
      add(this.root.querySelector('.hs-purchase-now'),'cta',105);
      add(this.root.querySelector('.icon-with-text'),'default',0);
      add(this.root.querySelector('.hs-pdp-field-info'),'default',0);
      this.root.querySelectorAll('.hs-premium-accordion').forEach((node,index)=>add(node,'line',Math.min(index,4)*55));

      const reveal=(item)=>{
        item.node.style.setProperty('--hs-reveal-delay',item.delay+'ms');
        item.node.dataset.hsRevealKind=item.kind;
        item.node.dataset.hsReveal='entered';
        if(item.node.matches('[data-hs2-relation-beacon]'))item.node.setAttribute('data-hs-motion-visible','');
      };

      if(!('IntersectionObserver'in window)){targets.forEach(reveal);return;}

      for(const item of targets){
        item.node.style.setProperty('--hs-reveal-delay',item.delay+'ms');
        item.node.dataset.hsRevealKind=item.kind;
        item.node.dataset.hsReveal='pending';
      }
      this.pdpRevealObserver=new IntersectionObserver(entries=>{
        for(const entry of entries){
          if(!entry.isIntersecting)continue;
          const item=targets.find(candidate=>candidate.node===entry.target);
          if(item)reveal(item);
          this.pdpRevealObserver.unobserve(entry.target);
        }
      },{threshold:.14,rootMargin:'0px 0px -5% 0px'});
      for(const item of targets)this.pdpRevealObserver.observe(item.node);
    };
    if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initPdpMotion,{once:true,signal:this.events.signal});
    else requestAnimationFrame(initPdpMotion);
    const action=this.root.querySelector('.hs-purchase-add');
    if(action&&'IntersectionObserver' in window){
      const updateVisibility=()=>document.body.toggleAttribute('data-hs-buying-passed',action.getBoundingClientRect().bottom<0);
      this.visibility=new IntersectionObserver(updateVisibility,{threshold:[0,.75,1]});
      this.visibility.observe(action);
      let pending=false;
      const schedule=()=>{if(pending)return;pending=true;requestAnimationFrame(()=>{pending=false;if(this.isConnected)updateVisibility();});};
      window.addEventListener('scroll',schedule,{passive:true,signal:this.events.signal});
      window.addEventListener('resize',schedule,{passive:true,signal:this.events.signal});
      window.addEventListener('pageshow',schedule,{signal:this.events.signal});
      updateVisibility();
    }
    const sticky=this.root.querySelector('[data-hs-sticky]')||document.querySelector('[data-hs-sticky]');
    const footer=document.querySelector('footer.footer,footer,.footer');
    if(sticky&&footer&&'IntersectionObserver' in window){
      this.footerVisibility=new IntersectionObserver(entries=>{
        document.body.toggleAttribute('data-hs-footer-visible',Boolean(entries[0]?.isIntersecting));
      },{threshold:[0,.05]});
      this.footerVisibility.observe(footer);
    }
    this.update();
  }
  disconnectedCallback(){cancelAnimationFrame(this.thumbFrame);this.events?.abort();this.thumbStateObserver?.disconnect();this.observer?.disconnect();this.visibility?.disconnect();this.discoveryVisibility?.disconnect();this.footerVisibility?.disconnect();this.beaconVisibility?.disconnect();this.pdpRevealObserver?.disconnect();document.body.removeAttribute('data-hs-buying-passed');document.body.removeAttribute('data-hs-footer-visible');this.ready=false;}
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["hs-ux-shortcuts"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('hs-catalogue'))customElements.define('hs-catalogue',class extends HTMLElement{
 connectedCallback(){if(this.ready)return;this.ready=true;this.events=new AbortController();this.track=this.querySelector('.hs-ux-shortcuts');this.progress=this.querySelector('.hs-catalogue-progress');this.update=()=>{const max=this.track.scrollWidth-this.track.clientWidth;this.progress.hidden=max<2;this.progress.style.setProperty('--hs-progress',String(max>0?Math.max(0,Math.min(1,this.track.scrollLeft/max)):0));};this.track.addEventListener('scroll',this.update,{passive:true,signal:this.events.signal});this.track.addEventListener('keydown',event=>{if(event.target!==this.track||!['ArrowLeft','ArrowRight'].includes(event.key))return;event.preventDefault();this.track.scrollBy({left:(event.key==='ArrowLeft'?-1:1)*(this.track.firstElementChild.getBoundingClientRect().width+parseFloat(getComputedStyle(this.track).columnGap)),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});},{signal:this.events.signal});this.resize=new ResizeObserver(this.update);this.resize.observe(this.track);this.update();}
 disconnectedCallback(){this.events?.abort();this.resize?.disconnect();this.ready=false;}
});
  } catch(e) { console.error(e); }
})();

})();
